import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useTranslate } from "react-polyglot";
import { green } from "@material-ui/core/colors";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";
import useDateUtils from "../../../../hooks/useDateUtils.js";

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: `2px solid ${theme.palette.borderColor.main}`,
    backgroundColor: "#F0EFEF",
    minHeight: 100,
    overflow: "hidden",
    display: "flex",
    padding: 10,
  },
  closeButton: {
    textTransform: "none",
    marginTop: 5,
  },
  downloadButton: {
    borderRadius: 10,
  },
  ellipsis: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    textAlign: "start",
  },
  onlineIcon: {
    marginRight: theme.spacing(1),
    width: 12,
    height: 12,
    display: "inline-block",
    borderRadius: "50%",
    backgroundColor: green[600],
    border: `2px solid white`,
    transform: "translateY(1px)",
  },
  chipBox: {
    backgroundColor: "#b0f2b6",
    fontWeight: 500,
    marginLeft: theme.spacing(2),
  },
}));

/** */
const MessagingBoxHeader = () => {
  const t = useTranslate();
  const { formatLastSeen } = useDateUtils();
  const classes = useStyles();
  const { selectedEmployeeInfo, lastWsIncomingMessage, closeConversation, currentConversation } = useChat();
  const [online, setOnline] = useState(false);

  const lastOnline =
    (selectedEmployeeInfo?.lastOnline && formatLastSeen(new Date(selectedEmployeeInfo.lastOnline), t)) || "";

  // Отслеживание онлайн статуса собеседника по сообщениям из сокета
  useEffect(() => {
    if (lastWsIncomingMessage && lastWsIncomingMessage.type === "onlineChanged") {
      setOnline(lastWsIncomingMessage.online);
    }
  }, [lastWsIncomingMessage]);

  // Отслеживание онлайн статуса собеседника при переключении между собеседниками
  useEffect(() => {
    if (selectedEmployeeInfo) {
      setOnline(selectedEmployeeInfo.online);
    }
  }, [selectedEmployeeInfo]);

  return (
    <Box className={classes.root}>
      <Box flex="1" margin="10px">
        <Box display="flex">
          <Typography classes={{ root: classes.ellipsis }} variant="h5">
            {selectedEmployeeInfo?.name}
          </Typography>
          {selectedEmployeeInfo?.jobTitle && (
            <Chip classes={{ root: classes.chipBox }} label={selectedEmployeeInfo.jobTitle} />
          )}
        </Box>
        <Typography classes={{ root: classes.ellipsis }}>
          {online && <span className={classes.onlineIcon} />}
          {online ? t("online") : lastOnline}
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="flex-end">
        {currentConversation?.id > 0 && ( // отрицательный id означает ненастоящий виртуальный диалог и закрыть его нельзя
          <Button className={classes.closeButton} variant="text" onClick={closeConversation}>
            {t("chat.close")}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default MessagingBoxHeader;
